import { HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';
import { CfgService } from 'src/app/cfg/cfg.service';

export class ReportCfg {
  public reportEndpointPattern: string;
}

export class PowerBiCfg {
  public powerBi: ReportCfg;
}

@Injectable({
  providedIn: 'root'
})
export class PowerBiCfgService extends CfgService<PowerBiCfg> {
  json: any = {
    powerBi: {
      reportEndpointPattern: "%{DashboardApiUrl}/reportaccessdata"
    }
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/powerbi/powerbi.cfg.json`;
  }

  /**
  * Carga las url en el json
  */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
